const RangeSlider = function() {
    // presets
    this.$handles = null;
    this.$inputs = null;
    this.$bar = null;
    this.vals = [];
    this.pos = [];
    this.touch = {
        dragging: false,
    };
    this.isMutli = false;
};

// append the appropriate step marker to $bar
RangeSlider.prototype.init = function(options, elem) {
    this.elem = elem;
    this.$elem = $(elem);

    this.options = options;

    this.$elem = this._build(this.options, this.$elem);

    // update starting pos
    this.$inputs = this.$elem.find('input, select');
    this._startingVals(this.$inputs);

    // bind events
    if (!this.options.disabled) {
        this._bindEvents(this.$handles);
    }

    this._bindEvents(this.$handles);

    return this;
};

// builds the range slider dom
RangeSlider.prototype._build = function(options, elem) {
    var handle = '<div class="range-slider__handle" />',
        highlight = '<div class="range-slider__highlight" />',
        $slider = $('<div class="field__range-slider">');

    // set range vars
    this.$minLabel = $('<div class="range-slider__label label--min">').text(options.minlabel);
    this.$maxLabel = $('<div class="range-slider__label label--max">').text(options.maxlabel);
    this.$barWrap = $('<div class="range-slider__bar-wrap">');
    this.$bar = $('<div class="range-slider__bar">');
    this.$handles = $(handle);

    // multi sliders require a highlight and an extra handle
    if (options.type === 'multi') {
        this.$handles = this.$handles.add(handle);
        this.$highlight = $(highlight);
    }

    // build slider bar
    this.$barWrap.append(this.$bar);
    this.$bar.append(this.$handles, this.$highlight);
    this._appendStepMakers(this.$bar, options);

    // build slider
    $slider.append(this.$barWrap);
    $slider.append(this.$minLabel, this.$maxLabel);

    return (
        this.$elem
            // hide whatever we're enhancing
            .wrapInner('<div style="display: none" />')
            // append html to element
            .append($slider)
    );
};

RangeSlider.prototype._bindEvents = function($handles) {
    var that = this,
        $body = $('body');

    // .range defines the namespace for the event

    // Start event biding
    $handles.on('touchstart mousedown', function(e) {
        that._start(e);
        // add class to modify cursor
        $body.addClass('range-slider--dragging');
        // bind events on start to prevent pollution
        // move
        $body.on('touchmove.range mousemove.range', function(rangeEvent) {
            that._move(rangeEvent);
        });
        // end
        $body.on('touchend.range mouseup.range', function(rangeEvent) {
            that._end(rangeEvent);
            // remove class to modify cursor
            $body.removeClass('range-slider--dragging');
            // clear the move and end events
            $body.off('.range');
        });
    });

    this.$barWrap.on('click', function(e) {
        if (!$(e.target).is('.range-slider__handle')) {
            var offset = that.$barWrap.offset().left,
                clickX = e.pageX,
                pos = Math.round(clickX - offset);

            that._moveHandleTo(pos);
            e.preventDefault();
        }
    });
};

// append the appropriate step marker to $bar
RangeSlider.prototype._appendStepMakers = function($bar, opts) {
    var i,
        left,
        stepCount = (opts.max - opts.min) / opts.step;

    if (stepCount <= opts.stepmin && opts.step) {
        for (i = 0; i < stepCount; i++) {
            left = (i / stepCount) * 100;

            if (i !== 0) {
                $bar.append($('<span class="range-slider__step">').css('left', left + '%'));
            }
        }
    }

    return $bar;
};

// sets the initial starting point for the handle
RangeSlider.prototype._startingVals = function($inputs) {
    $inputs.each(
        $.proxy(function(i, item) {
            // each of the inputs
            var val = parseInt($(item).val(), 10);
            val = val || 0;

            this.setHandle(i, val, true);
            //this.dragHandle(i, val);
        }, this)
    );
};

// touch/mouse start event
RangeSlider.prototype._start = function(e) {
    if (this.touch.dragging) {
        return; // if already started
    }

    var point = /touch/.test(e.type) ? e.originalEvent.touches[0] : e;

    this.touch.dragging = true;
    this.touch.pointX = point.pageX;
    this.touch.pointY = point.pageY;
    this.touch.stepsX = 0;
    this.touch.stepsY = 0;
    this.touch.directionLocked = false;
    this.touch.tgt = $(e.target);

    // the actual touch location
    this.touch.x = this.$bar.offset().left;
    // the this.touch relative to its parents (original this.touch)
    this.touch.ox = -this.touch.x + this.touch.pointX;
    // add active style
    this.touch.tgt.attr('data-rangeslider-active', 'true');
    e.preventDefault();
};

// touch/mouse move event
RangeSlider.prototype._move = function(e) {
    /* jshint maxcomplexity: 7 */
    if (!this.touch.dragging || this.stop) {
        return;
    }

    var nx,
        $handle,
        point = /touch/.test(e.type) ? e.originalEvent.touches[0] : e;

    this.touch.stepsX += Math.abs(point.pageX - this.touch.pointX);
    this.touch.stepsY += Math.abs(point.pageY - this.touch.pointY);

    // We take a 10px buffer to figure out the direction of the user event
    if (this.touch.stepsX < 10 && this.touch.stepsY < 10) {
        return;
    }

    // We are scrolling vertically, so give the control back to the browser
    if (!this.touch.directionLocked && this.touch.stepsY > this.touch.stepsX) {
        this.touch.dragging = false;
        return;
    }

    e.preventDefault();
    this.touch.directionLocked = true;

    if (this.touch.ox) {
        nx = this.touch.x - parseInt(point.pageX, 10);
        $handle = this.touch.tgt;

        // update the handle position
        this.dragHandle($handle.index(), this.getPercentage(-nx));
    }
};

// touch/mouse end event
RangeSlider.prototype._end = function(e) {
    if (!this.touch.dragging) {
        return false;
    }

    // remove active style
    this.touch.tgt.removeAttr('data-rangeslider-active');
    // clear any existing vars and stop the drag
    this.touch.x = null;
    this.touch.tgt = null;
    this.touch.ox = null;
    this.touch.dx = 0;
    this.touch.dragging = false;

    return false;
};

// move the handle/s
// handles should never be moved without updating their value, or
// adjusting the highlight, so update it here
RangeSlider.prototype.dragHandle = function(index, percent, first) {
    // set accessable vars
    // this is used to set iput properties
    this.vals[index] = this.calcValue(percent, 1);
    // this is used by the visual UI
    this.pos[index] = this.calcValue(percent);

    if (!first) {
        this._updateInputs(this.vals);
    }
    this._updateLabels(this.vals);

    // move the handle
    this._moveHandle(this.$handles.eq(index), this.pos[index]);

    // move the highlight
    this._moveHightlight(this.$highlight, this.pos);
};

// set a handle positon using a field value (used on load)
RangeSlider.prototype.setHandle = function(index, val, first) {
    this.dragHandle(index, this.calcPos(val, 1), first);
};

// move the handle
RangeSlider.prototype._moveHandle = function($handle, value) {
    $handle.css('left', this.calcPos(value) + '%').attr('data-rangeslider-val', value);
};

// requires a px number. This is triggered by clicking the range bar
RangeSlider.prototype._moveHandleTo = function(x) {
    var percent = this.getPercentage(x),
        moveTo = this.calcValue(percent),
        index = this.calcClosestHandle(this.vals, moveTo);

    this.dragHandle(index, percent);
};

// move the hightlight
// TODO: try to do this in css
RangeSlider.prototype._moveHightlight = function($highlight, values) {
    if (!$highlight || !$highlight.length) {
        return;
    }

    $highlight.css({
        left: this.calcPos(Math.min.apply(null, values)) + '%',
        right: 100 - this.calcPos(Math.max.apply(null, values)) + '%',
    });
};

// updates the inputs based on the lowest number being first
RangeSlider.prototype._updateInputs = function(values) {
    if (values[0] && values[1]) {
        this.$inputs
            .eq(0)
            .val(Math.min.apply(null, values))
            .trigger('change');
        this.$inputs
            .eq(1)
            .val(Math.max.apply(null, values))
            .trigger('change');
    } else {
        this.$inputs
            .eq(0)
            .val(values[0])
            .trigger('change');
    }
};

// updates the labels to show the selected value
// TODO: this will eventually change to tooltips
RangeSlider.prototype._updateLabels = function(values) {
    var text;
    if (values[0] && values[1]) {
        text = this.options.labelprefix + Math.min.apply(null, values);
        this.$minLabel.text(text);
        this.$maxLabel.text(text);
    }
};

// converts distance in pixels (x) to a %'age
RangeSlider.prototype.getPercentage = function(x) {
    var range = this.$bar.width();
    var percent = Math.round((x / range) * 100);

    if (percent < 0) {
        percent = 0;
    }
    if (percent > 100) {
        percent = 100;
    }
    return percent;
};

// converts a value (val) to a %'age
RangeSlider.prototype.calcPos = function(val, step) {
    var diff = this.options.max - this.options.min;

    if (this.options.step || step) {
        return ((val - this.options.min) * 100) / diff;
    } else {
        return val;
    }
};

// converts %'age of value (p) to a step
RangeSlider.prototype.calcValue = function(p, step) {
    var diff = this.options.max - this.options.min;
    step = this.options.step || step;

    if (step) {
        p = (diff * p) / 100;
        return this.options.min + Math.round(p / step) * step;
    } else {
        return p;
    }
};

RangeSlider.prototype.calcClosestHandle = function(arr, goal) {
    var closest = null,
        closestIndex = null;

    $.each(arr, function(i, k) {
        if (closest === null || Math.abs(k - goal) < Math.abs(closest - goal)) {
            closest = k;
            closestIndex = i;
        }
    });

    return closestIndex;
};

export default RangeSlider;



// WEBPACK FOOTER //
// ./src/web/js/app/modules/range-slider-lib.js